import { z } from 'zod/v4';

export const CreateCompanyResponseSchema = z.object({
  id: z.string(),
  createdAt: z.coerce.date().nullable(),
  createdByUserId: z.string().nullable(),
  createdByUserName: z.string().nullable(),
  createdByImpersonateId: z.string().nullable(),
  createdByCompanyId: z.string().nullable(),
  updatedAt: z.coerce.date().nullable(),
  updatedByUserId: z.string().nullable(),
  updatedByUserName: z.string().nullable(),
  updatedByImpersonateId: z.string().nullable(),
  updatedByImpersonateName: z.string().nullable(),
  updatedByCompanyId: z.string().nullable(),
  updatedByCompanyName: z.string().nullable(),
  createdByApiKeyId: z.string().nullable(),
  createdByApiKeyLabel: z.string().nullable(),
  updatedByApiKeyId: z.string().nullable(),
  updatedByApiKeyLabel: z.string().nullable(),
  isDemoCompany: z.number().nullable(),
  isRemoved: z.number().nullable(),
  isClientCompany: z.number().nullable(),
  oryOrganizationId: z.string().nullable(),
});

export type CreateCompanyResponse = z.infer<typeof CreateCompanyResponseSchema>;
